// Shared store modules for monorepo
// Import all store modules
import cart from './cart.js';
import web_cart from './web_cart.js';
import token from './token.js';
import state from './state.js';
import geo from './geo.js';
import allergens from './allergens.js';
import training from './training.js';

// Export individual modules for named imports
export { cart, web_cart, token, state, geo, allergens, training };

// Create a function to configure the complete store
export const createVuexStore = () => {
  return {
    modules: {
      cart,
      web_cart,
      token,
      state,
      geo,
      allergens,
      training,
    },
  };
};

// For apps that want specific modules only
export const createCartStore = () => {
  return {
    modules: { cart, token },
  };
};

export const createBridgeStore = () => {
  return {
    modules: { token, state },
  };
};

// Default export with all modules for convenience
export default {
  cart,
  web_cart,
  token,
  state,
  geo,
  allergens,
  training,
  createCartStore,
  createBridgeStore
};
